@if(props['multiple']) {
<fc-multiple-select [field]="field" />
} @else {
<fc-single-select [field]="field" />
}
